export const getResource = (str) => {
  if (str.indexOf("/public")===0) {
    return str
  } else {
    return "/api/report-resources/"+str
  }
  // if (process.env.NODE_ENV === 'development') {
  //   return "/api/report-resourcaes/"+str
  // } else {
  //   return (/*store.getState().resourceOrigin || */location.origin) + '/resource.php?resourceUID=' + str + '&reportUID=' /*+ getReportId()*/
  // }
}

export const simpleFetch = (url,extra) => fetch(url, {
  credentials: 'same-origin',
  method: 'GET',
  ...extra
}).then(e => { if (e.status >= 400) { return Promise.reject(e) } else { return e.text() } })
  .then(e => {
    if (e && typeof e === 'string') {
      try {
        return JSON.parse(e)
      } catch (e) {
        return e
      }
    } else {
      return e
    }
  })


export const queryHasValue = (url,key,value) =>
  url.indexOf('?'+key+'='+value)>=0 || url.indexOf('&'+key+'='+value)>=0


const splitAt = (str,pos) => [str.slice(0,pos),str.slice(pos)]

export const formatCurrency = (price) => {
  const [left,right] = splitAt(("00"+Math.round(Math.abs(price))),-2)
  return left.replace(/^0+(\d)/,'$1').replace(/\d(?=(\d{3})+$)/g, '$&,') + '.' + right
}

const DAY_MILLSECS = 1000 * 60 * 60 * 24
export const daysLeft = (millisecs) => Math.round(((millisecs) - Date.now()) / DAY_MILLSECS)


export const toPrice = formatCurrency

export const normalizeSubscription = (stripeSubscriptionOrEmpty, hasCard) => {
  const stripeSubscription = stripeSubscriptionOrEmpty  || {status: 'canceled'}
  return (stripeSubscription.status === 'active' || stripeSubscription.status === 'trialing') && stripeSubscription.cancelAtPeriodEnd ? {...stripeSubscription,status:'canceled_renewal'} :
    stripeSubscription.status === 'trialing' && hasCard ? {...stripeSubscription,status:'active'} :
      stripeSubscription
}
export const stripeIntervalToInterval = (interval,capitalize) => {
  const irregular_intervals = {'day': 'dai'}
  const result = (irregular_intervals[interval] || interval)+"ly"
  return (capitalize ? result.charAt(0).toUpperCase() : result.charAt(0)) + result.slice(1);
}
export const stripeIntervalToAbbreviation = (interval) => {
  return {'year':'yr','month':'mo', 'week': 'wk', 'day': 'day'}[interval]
}

export const getPlanType = (type) => ({
  "REPORT_BASIC": "Report Basic",
  "REPORT_BASIC_V2": "Report Free",
  "REPORT_BASIC_V3": "Report Basic",
  "REPORT_STANDARD": "Report Standard",
  "REPORT_STANDARD_V2": "Report Standard",
  "REPORT_PRO": "Report Pro",
  "STORAGE_PRO": "Storage Pro",
  "STORAGE_STANDARD": "Storage Standard"
})[type]

export const getAuthorities = (type) => (type.indexOf("REPORT_BASIC")===0) ? ["ROLE_USER"] : ["ROLE_USER","KEY_IMAGES"]



// WEBPACK FOOTER //
// ./src/javascripts/lib/index.js